import React from "react";

const FolderIcon = () => {
  return (
    <svg
      width="21"
      height="18"
      viewBox="0 0 21 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="folder-icon"
    >
      <path
        d="M1.77203 17.25C1.52299 17.25 1.28414 17.1534 1.10804 16.9815C0.93194 16.8096 0.833008 16.5764 0.833008 16.3333V1.66667C0.833008 1.42355 0.93194 1.19039 1.10804 1.01849C1.28414 0.846577 1.52299 0.75 1.77203 0.75H8.73396L10.612 2.58333H17.7354C17.9845 2.58333 18.2233 2.67991 18.3994 2.85182C18.5755 3.02373 18.6745 3.25688 18.6745 3.5V6.25H16.7964V4.41667H9.83449L7.95645 2.58333H2.71106V13.5815L4.11959 8.08333H20.083L17.9139 16.5561C17.863 16.7543 17.7457 16.9303 17.5807 17.056C17.4157 17.1817 17.2123 17.25 17.003 17.25H1.77203ZM17.6772 9.91667H5.58635L4.17781 15.4167H16.2687L17.6772 9.91667Z"
        fill="#333333"
      />
    </svg>
  );
};

export default FolderIcon;
